import { LoadingButton } from '@mui/lab';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import PropTypes from 'prop-types';

const RepostCentralFillDialog = ({ open, onClose, orderId, onConfirm, isLoading }) => {
  const handleClose = () => {
    if (isLoading) return;
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={isLoading ? undefined : handleClose}
      aria-describedby='repost-compounding-dialog-title'
      fullWidth
      maxWidth='xs'
    >
      <DialogTitle id='repost-compounding-dialog-title'>Repost Compounding Order</DialogTitle>

      <DialogContent>
        <Typography variant='body2' color='text.secondary'>
          Are you sure you want to resend order <strong>{orderId}</strong> to the compounding
          pharmacy?
        </Typography>
      </DialogContent>

      <DialogActions>
        <Button variant='outlined' color='secondary' onClick={handleClose} disabled={isLoading}>
          No
        </Button>
        <LoadingButton variant='contained' loading={isLoading} onClick={onConfirm}>
          Yes, Repost
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

RepostCentralFillDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  orderId: PropTypes.string,
  onConfirm: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
};

RepostCentralFillDialog.defaultProps = {
  orderId: undefined,
  isLoading: false,
};

export default RepostCentralFillDialog;
